module.exports = __webpack_public_path__ + "static/media/French.e8305cdd.jpg";